import { useCallback, useState } from 'react';

export const useModal = initialState => {
    const [isOpened, setIsOpened] = useState(initialState);
    const toggleModal = useCallback(() => setIsOpened(!isOpened), [isOpened]);

    return [isOpened, toggleModal];
};
